import React, { FC } from 'react';
require("./Checkbox-Box.css");
var styles = {
  "Root": "Checkbox-Box-module-Root_1fL",
  "BoxCheckmarkContainer": "Checkbox-Box-module-BoxCheckmarkContainer_ZrW",
  "Checkmark": "Checkbox-Box-module-Checkmark_3DE",
  "checkboxCheck": "Checkbox-Box-module-checkboxCheck_3RT",
  "checkboxUncheck": "Checkbox-Box-module-checkboxUncheck_3Bb"
};
export const CheckboxBox = ({
  state,
  'aria-disabled': ariaDisabled
}) => /*#__PURE__*/React.createElement("span", {
  className: styles.Root,
  role: "checkbox",
  "aria-checked": state,
  "aria-disabled": ariaDisabled
}, /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "11",
  viewBox: "0 0 14 11",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false",
  className: styles.BoxCheckmarkContainer
}, /*#__PURE__*/React.createElement("path", {
  className: styles.Checkmark,
  d: "M1 6L5 10L13 1",
  stroke: "white",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));